import axiosInstance from './axiosConfig';

export interface OpenChatPaymentCheckoutResponse {
  success: boolean;
  already_paid?: boolean;
  status?: string;
  checkout_url?: string | null;
  session_id?: string | null;
  expires_at?: string | null;
  error?: string;
}

export interface CancelChatPaymentResponse {
  success: boolean;
  status?: string;
  payment_status?: string;
  already_cancelled?: boolean;
  error?: string;
}

/** Client opens hosted Stripe Checkout for a chat payment request. */
export async function openChatPaymentCheckout(
  transactionId: string
): Promise<OpenChatPaymentCheckoutResponse> {
  const response = await axiosInstance.post<OpenChatPaymentCheckoutResponse>(
    `/api/chat-payments/${encodeURIComponent(transactionId)}/checkout`
  );
  return response.data;
}

/** Client cancels a pending chat payment request (API retained; UI no longer exposes Cancel). */
export async function cancelChatPayment(
  transactionId: string
): Promise<CancelChatPaymentResponse> {
  const response = await axiosInstance.post<CancelChatPaymentResponse>(
    `/api/chat-payments/${encodeURIComponent(transactionId)}/cancel`
  );
  return response.data;
}
